export default function Versao1010() {
  return (
    <section className="space-y-6">
      <h2 className="text-lg font-semibold text-black">Histórico – Versão 1.0.10</h2>

      <ul className="space-y-4 text-black text-base leading-relaxed">
        <li>
          <strong>🗂️ Tela de Chamados:</strong>
          <ul className="list-disc list-inside ml-4 space-y-1">
            <li>Layout mais suave e elegante.</li>
            <li>Botões reposicionados para o lado direito.</li>
            <li>Botões redesenhados e mais elegantes.</li>
            <li>Correção no botão de excluir.</li>
            <li>Soma total dos chamados corrigida.</li>
            <li>Filtros funcionando corretamente.</li>
          </ul>
        </li>

        <li>
          <strong>📅 Tela de Agendamentos:</strong>
          <ul className="list-disc list-inside ml-4 space-y-1">
            <li>Botões Salvar e Cancelar alinhados à direita.</li>
            <li>Layout de botões atualizado e moderno.</li>
            <li>Correção do botão Detalhes.</li>
            <li>Filtros e cards acima da tabela funcionando.</li>
          </ul>
        </li>

        <li>
          <strong>🔑 Tela de Login:</strong>
          <ul className="list-disc list-inside ml-4 space-y-1">
            <li>Logo da empresa adicionada.</li>
            <li>Novo nome do sistema.</li>
            <li>Cores atualizadas para o novo layout.</li>
          </ul>
        </li>

        <li>
          <strong>⚡ Sistema Geral:</strong>
          <ul className="list-disc list-inside ml-4 space-y-1">
            <li>Novo design com paleta moderna.</li>
            <li>Transições suaves com <code>Framer Motion</code>.</li>
            <li>Maior performance e fluidez na navegação.</li>
          </ul>
        </li>
      </ul>
    </section>
  );
}